module.exports = __webpack_public_path__ + "img/doubleFile.d0528583.png";